import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import Checkbox from '../Atoms/Checkbox';

const propTypes = exact({
  handleFieldChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  notRequiredOptionText: PropTypes.string,
  partyMembers: PropTypes.array,
  requiredOptionText: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
});

const defaultProps = {
  handleFieldChange: () => false,
  isDisabled: false,
  notRequiredOptionText: 'Covered elsewhere',
  partyMembers: [],
  requiredOptionText: 'Required',
  text: null,
  title: 'Insurance',
};

const formatName = (partyMember, index, isDisabled) => {
  const prefix = isDisabled ? partyMember.fullName?.prefix : partyMember.fullName?.prefix.value;
  const forename = isDisabled
    ? partyMember.fullName?.forename
    : partyMember.fullName?.forename.value;
  const surname = isDisabled ? partyMember.fullName?.surname : partyMember.fullName?.surname.value;

  if (prefix && forename && surname) {
    return `${prefix} ${forename.charAt(0)} ${surname}`;
  }

  if (index === 0) return 'Lead Party Member';
  return `Party Member ${index + 1}`;
};

function Insurance(props) {
  return (
    <div className="Insurance">
      <h3 className="Insurance_title">{props.title}</h3>
      <div className="Insurance_content">
        <div className="Insurance_fieldset">
          {props.partyMembers.map((partyMember, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="Insurance_field">
              <div className="Insurance_fieldItem">
                {formatName(partyMember, index, props.isDisabled)}
              </div>
              {props.isDisabled && (
                <div className="Insurance_fieldItem">
                  {partyMember.insuranceCover === true && props.requiredOptionText}
                  {partyMember.insuranceCover === false && props.notRequiredOptionText}
                </div>
              )}
              {!props.isDisabled && (
                <>
                  <div className="Insurance_fieldItem">
                    <Checkbox
                      fieldID={`partyMembers[${index}].insuranceCover1`}
                      fieldName={`partyMembers[${index}].insuranceCover`}
                      fieldValue="true"
                      isChecked={partyMember.insuranceCover.value === true}
                      handleChange={props.handleFieldChange}
                      inputType="radio"
                      modifier="ghost"
                      text={props.requiredOptionText}
                    />
                  </div>
                  <div className="Insurance_fieldItem">
                    <Checkbox
                      fieldID={`partyMembers[${index}].insuranceCover2`}
                      fieldName={`partyMembers[${index}].insuranceCover`}
                      fieldValue="false"
                      isChecked={partyMember.insuranceCover.value === false}
                      handleChange={props.handleFieldChange}
                      inputType="radio"
                      modifier="ghost"
                      text={props.notRequiredOptionText}
                    />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
        {props.text && (
          <div
            className="Insurance_body"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: props.text }}
          />
        )}
      </div>
    </div>
  );
}

Insurance.propTypes = propTypes;
Insurance.defaultProps = defaultProps;

export default Insurance;
